import analytics from '@/shared-utils/analytics'

const createHandlers = (url: string, index: string) => {
  const onClick = () => {
    analytics.fireGA4Event({
      event: 'select_promotion',
      attributes: {
        type: 'marketing',
        bundle_flag: 'y',
        bundle_type: '',
        product_name: 'bundle',
        promotion_name: 'bundle',
        creative_name: 'package_promo',
        items: [
          {
            index,
            item_name: 'bundle',
            item_id: 'actionCard',
          },
        ],
      },
    })
  }
  return {
    role: 'link' as const,
    href: url,
    anchorProps: { target: '_blank', rel: 'noopener noreferrer' } as const,
    onClick,
  }
}

export default [
  {
    mediaType: 'image' as const,
    mediaContent: {
      src: 'https://s1.pclncdn.com/design-assets/next-landing/assets/images/destinations/popular/vegas.jpeg?opto&auto=avif,webp',
      alt: 'Las Vegas destination',
    },
    heading: 'Limited time deals to Las Vegas',
    body: 'Save big on your trip when you bundle',
    ...createHandlers('https://www.priceline.com/partner/v2/packages-lasvegas', '1'),
  },
  {
    mediaType: 'image' as const,
    mediaContent: {
      src: 'https://s1.pclncdn.com/design-assets/next-landing/assets/images/destinations/popular/cancun.png?opto&auto=avif,webp',
      alt: 'Mexico and Caribbean destination',
    },
    heading: 'Limited time deals to Mexico and the Caribbean',
    body: 'Save big on your trip when you bundle',
    ...createHandlers('https://www.priceline.com/partner/v2/mexico-caribbean-packages', '2'),
  },
  {
    mediaType: 'image' as const,
    mediaContent: {
      src: 'https://s1.pclncdn.com/design-assets/next-landing/assets/images/destinations/popular/florida.png?opto&auto=avif,webp',
      alt: 'Florida destination',
    },
    heading: 'Limited time deals to Florida',
    body: 'Save big on your trip when you bundle',
    ...createHandlers('https://www.priceline.com/partner/v2/packages-florida', '3'),
  },
] as const
